import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id", "onClick"]
const _hoisted_2 = ["id", "onClick"]
const _hoisted_3 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.range(3), (i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.abacus_digits.keys(), (j) => {
              return (_openBlock(), _createElementBlock("td", {
                class: _normalizeClass({empty: ($setup.abacus_digits[j] >=10)?
                    (i===0):
                    (
                        ($setup.abacus_digits[j] >= 5)?(i===1):(i===2)
                    )}),
                key: j,
                id: `h${i}_${j}`,
                onClick: () => { $setup.topBeadClicked(i, j); }
              }, "﻿", 10 /* CLASS, PROPS */, _hoisted_1))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.abacus_digits.keys(), (j) => {
            return (_openBlock(), _createElementBlock("td", { key: j }, _toDisplayString($setup.abacus_digits[j]), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("tfoot", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.range(6), (i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.abacus_digits.keys(), (j) => {
              return (_openBlock(), _createElementBlock("td", {
                class: _normalizeClass({empty: i === ($setup.abacus_digits[j] % 5)}),
                key: j,
                id: `f${i}_${j}`,
                onClick: () => { $setup.bottomBeadClicked(i, j); }
              }, "﻿", 10 /* CLASS, PROPS */, _hoisted_2))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => ($setup.resetNumbers && $setup.resetNumbers(...args))),
      disabled: $setup.is_running
    }, "Reset", 8 /* PROPS */, _hoisted_3)
  ], 64 /* STABLE_FRAGMENT */))
}